import { Box, ScrollArea, Group } from '@mantine/core'
import { MarkdownRenderer } from '../common/MarkdownRenderer'
import { GeneratedContentPanel } from '../game/GeneratedContentPanel'
import { useTypewriter } from '../../hooks/useTypewriter'
import { SectionLabel } from './SectionLabel'
import { SpeakButton } from './SpeakButton'

// The beat text. Capped reading measure (~62ch, set in CSS so it tracks the
// S/M/L text-size scale), typewriter pacing on narrative beats, click to skip.
// Paged advance (not free scroll) is driven by the Response Dock's Continue/Next
// in the parent; this just renders the current page of text.
//
// speakContext ({ sessionId, beatId }) enables the per-segment speak buttons.
// When absent (legacy interface / no session) the buttons render nothing.
export function StoryStream({ currentBeat, characters, generatedContent, speakContext = null }) {
  const beatContent = currentBeat?.content || ''
  const isNarrative = currentBeat?.beat_type === 'narrative'
  const isGenerated =
    currentBeat?.beat_type === 'character_response' ||
    currentBeat?.beat_type === 'narrative_response' ||
    currentBeat?.beat_type === 'resolution'

  const { displayed, isDone, skip } = useTypewriter(beatContent, {
    enabled: isNarrative,
    beatId: currentBeat?.id,
  })

  // Plain narrative beats speak their authored content as segment 0. Only offer
  // the control once the typewriter has finished, so it doesn't read a partial.
  const narrativeSegment = isNarrative && isDone && speakContext?.sessionId && currentBeat?.id
    ? { id: `beat:${currentBeat.id}:0`, kind: 'beat', sessionId: speakContext.sessionId, beatId: currentBeat.id, segmentIndex: 0 }
    : null

  return (
    <Box className="g2-stream" px="lg" pt="xs">
      <Group justify="space-between" align="center" wrap="nowrap">
        <SectionLabel>Story</SectionLabel>
        {narrativeSegment && <SpeakButton segment={narrativeSegment} />}
      </Group>
      <ScrollArea
        style={{ flex: 1, minHeight: 0, cursor: !isDone ? 'pointer' : 'default' }}
        type="auto"
        onClick={() => { if (!isDone) skip() }}
      >
        {/* key on beat id so the fade-in replays per page */}
        <Box key={currentBeat?.id} className="g2-stream-measure g2-beat-enter" pb="lg">
          <Box style={{ lineHeight: 1.7 }}>
            <MarkdownRenderer content={isNarrative ? displayed : beatContent} />
          </Box>
          {isGenerated && (
            <GeneratedContentPanel
              content={generatedContent}
              beatType={currentBeat.beat_type}
              characters={characters}
              speakContext={speakContext}
            />
          )}
        </Box>
      </ScrollArea>
    </Box>
  )
}
